// extracted by mini-css-extract-plugin
export default {"bg":"KeycloakLoading_bg__bfUxn","error":"KeycloakLoading_error__zZpEE","container":"KeycloakLoading_container__mCF5w"};